import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { SnapIcon } from '../SnapIcon';
import VgsCollectValue from '../VgsInput/VgsCollectValue';
import { phoneValidation } from '../VgsInput/validations';
import useFieldTracker from '../../hooks/useFieldTracker';
import LoadingSpinner from '../LoadingSpinner';
import { SnapButton } from '../SnapButton';

Modal.setAppElement('body');

function EditPhoneModal({
  isOpen,
  toggle,
  form,
  onSubmit,
}: {
  isOpen: boolean;
  toggle: () => void;
  form: VGSForm<{ vaultKybUpdate: string }>;
  onSubmit: (form: VGSForm<unknown>) => void;
}): React.JSX.Element {
  const [emptyFields, onEmptyChange] = useFieldTracker(['kybPhoneNumber']);
  const [invalidFields, onInvalidChange] = useFieldTracker(['kybPhoneNumber']);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const sharedProps = {
    type: 'text' as VgsFieldType,
    required: true,
    showRequiredAsterisk: true,
    onEmptyChange,
    onInvalidChange,
    form,
    fieldErrors: [],
  };

  useEffect(() => {
    const newValidity = emptyFields.length === 0 && invalidFields.length === 0;
    if (newValidity !== isValid) {
      setIsValid(newValidity);
    }
  }, [emptyFields, invalidFields, isValid]);
  return (
    <Modal
      overlayClassName={
        'flex inset-0 fixed z-50 backdrop-blur-sm overflow-y-auto bg-black/30'
      }
      className={`tablet:rounded-lg m-auto bg-white p-4 shadow-md`}
      isOpen={isOpen}
    >
      {isLoading && <LoadingSpinner />}
      <div
        style={{
          visibility: isLoading ? 'hidden' : 'visible',
          height: isLoading ? 0 : 'auto',
        }}
      >
        <div className={`flex flex-row-reverse p-2 `}>
          <SnapIcon
            icon={'x-solid'}
            color={'#64748B'}
            onClick={toggle}
            className='cursor-pointer'
          />
        </div>
        <div className='flex flex-col items-center'>
          <SnapIcon
            icon='pencil-alt'
            className='rounded-full border border-blue-900 bg-blue-600 text-white hover:bg-blue-800 active:bg-blue-800 active:border-blue-500'
            size='lg'
          />
          {form !== undefined && (
            <VgsCollectValue
              name='kybPhoneNumber'
              label='Phone Number'
              placeholder='(XXX) XXX-XXXX'
              maskInput={{
                mask: '(999) 999-9999',
              }}
              validations={[phoneValidation]}
              {...sharedProps}
              form={form}
            />
          )}
        </div>
        <div className='flex flex-row gap-2 my-2'>
          <div className=''>
            <SnapButton
              variant='primary'
              size='md'
              fullWidth
              onClick={async () => {
                if (form === undefined) {
                  throw new Error('VGSForm not provided');
                }
                setIsLoading(true);
                await onSubmit(form);
                setIsLoading(false);
              }}
              className='mb-2'
              disabled={isValid === false}
            >
              Update
            </SnapButton>
          </div>
          <div className=''>
            <SnapButton
              variant='tertiary'
              size='md'
              fullWidth
              onClick={toggle}
              className='mb-2'
            >
              Cancel
            </SnapButton>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default EditPhoneModal;
